export default {
  CUSTOM_MODAL_OK: 'CUSTOM_MODAL_OK',
  CUSTOM_MODAL_NOK: 'CUSTOM_MODAL_NOK',
  CUSTOM_MODAL_VALUE: 'CUSTOM_MODAL_VALUE',
  YES_NO_MODAL: 'YES_NO_MODAL'
}
